import React, { useEffect } from 'react';
import { useAuth } from './AuthContext';
import { vendorApi } from '../store/vendorApi';
import { AbilityProvider } from './AbilityContext';
import type { VendorPermission } from '@clareefai/types';

interface AbilityProviderWrapperProps {
  children: React.ReactNode;
}

/**
 * Fetches permissions when authenticated and provides CASL Ability context.
 * When not authenticated or loading, provides empty ability (all checks fail).
 */
export const AbilityProviderWrapper: React.FC<AbilityProviderWrapperProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { data: permissionsData, isLoading } = vendorApi.useGetPermissionsQuery(undefined, {
    skip: !isAuthenticated,
  });

  const permissions: VendorPermission[] = permissionsData?.permissions ?? [];

  useEffect(() => {
    if (permissionsData && !isLoading) {
      console.log('[Auth] Backend permissions (from GET /vendors/me/permissions):', {
        role: permissionsData.role,
        permissions: permissionsData.permissions,
      });
    }
  }, [permissionsData, isLoading]);

  return <AbilityProvider permissions={permissions}>{children}</AbilityProvider>;
};
